const wpAdminClasses = (classes: string) => {
    return classes
        .split(' ')
        .map((c) => {
            switch (c) {
                case 'has-bold':
                    return 'text-bold';
                case 'has-text-align-center':
                    return 'text-center';
                default:
                    return c;
            }
        })
        .join(' ')
        .trim();
};

export default wpAdminClasses;
